import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { autoRefreshManager } from '../lib/api';

/**
 * Hook to initialize auto-refresh functionality
 * This should be called once at the app level to set up the query client
 */
export const useAutoRefresh = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    // Initialize the auto-refresh manager with the query client
    autoRefreshManager.setQueryClient(queryClient);
    
    console.log('Auto-refresh manager initialized');
    
    return () => {
      // Cleanup if needed
      autoRefreshManager.setQueryClient(null);
    };
  }, [queryClient]);
};

export default useAutoRefresh;